<template>
  <div class="card br-16 p-x3 w-80p" style="box-shadow: 0 2px 8px rgba(0,0,0, 0.10)">
    <div>
      <div class="t-xl m-b4 ta-c bold">Automatically invite employees to channels</div>
      <div class="t m-bx3 ta-c gray">Employees will be added to the channels you select below</div>
    </div>
    <div class="t">Select the channels you want new hires to join:</div>
    <div class="separator m-vx1" />
    <div class="t gray m-bx1">Private channels are only visible if Donut is a member of them</div>
    <donut-selector-prefabs-channel
      v-model="selectedChannels"
      :include-private="true"
      :is-multi="true"
    />
    <div class="f-h f-ac fc-ae m-tx3">
      <a class="link m-rx2" @click="clickSkip">Skip</a>
      <donut-button
        :disabled="saveDisabled"
        :is-loading="isSaving"
        @click="clickSave"
      >
        Save
      </donut-button>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import Network from '../../../../lib/api/network';

  const { dispatch, state } = useStore();

  const events = computed(() => state.journeyBuilderWorkflow.events_requiring_user_input.channel_inviting || []);
  const selectedChannels = ref(events.value[0].channels || []);
  const isSaving = ref(false);
  const saveDisabled = computed(() => !selectedChannels.value.length);

  const saveResults = (channels, skip = false) => {
    isSaving.value = true;

    // All channel inviting events will get the same channels for now, because there really should only be one
    // and I'm trying to save time.
    Network.put(
      `/journey_builder/${state.journeyBuilderWorkflow.id}/update_draft_events`,
      {
        events: events.value.map(e => ({
          id: e.id,
          channel_ids: channels.map(c => c.id),
          requires_user_input_type: null, // Getting channel_ids resolves them, they no longer need user input.
          do_not_create: skip,
        })),
      },
      {
        success: () => {
          // Wipe out this field because they were all resolved. This moves the page along too.
          state.journeyBuilderWorkflow.events_requiring_user_input.channel_inviting = [];
        },
        error: () => {
          dispatch('setErrorToast');
        },
        complete: () => {
          isSaving.value = false;
        },
      },
    );
  };

  const clickSkip = () => {
    saveResults([], true);
  };

  const clickSave = () => {
    if (saveDisabled.value) return;

    saveResults(selectedChannels.value);
  };
</script>
